import { render } from "./PaymentStatus.vue?vue&type=template&id=b9a817cc&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"

import "./PaymentStatus.vue?vue&type=style&index=0&id=b9a817cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a817cc"]])

export default __exports__